import React from "react";
import { map } from "ramda";
import styled from "styles/styled_components";
import title from "styles/title";

import { ICategoryWithRoles } from "helpers/schedule/action_bar/filters";
import { IRootStateProps } from "types/reducers";

import CategoryRoleList from "components/schedule/action_bar/category_role_list";

const StyledForm = styled.form`
  display: flex;
  flex-basis: 100%;
  text-align: right;
`;

const StyledWrapper = styled.div`
  height: ${({ theme }) => `${25 * theme.rawGridBase}px`};
  margin-left: auto;
  max-width: ${({ theme }) => `${50 * theme.rawGridBase}px`};
  min-width: ${({ theme }) => `${42 * theme.rawGridBase}px`};
  overflow-x: hidden;
  overflow-y: auto;
  padding: ${({ theme }) => `${theme.spacing.medium}`};
  text-align: left;
`;

const StyledChecklistTitle = styled.div`
  color: ${({ theme }) => theme.colors.dsGrayDark};
  border-bottom: 1px solid ${props => props.theme.colors.dsGrayLight};
  margin-bottom: ${({ theme }) => theme.spacing.small};
  ${title}
`;

interface IFilters {
  categoriesWithRoles: ICategoryWithRoles[];
  filters: IRootStateProps["filters"];
  toggleRole: (role: string) => void;
  toggleCategory: (category: string) => void;
}

function Filters({
  filters,
  categoriesWithRoles,
  toggleRole,
  toggleCategory,
}: IFilters) {
  const checkboxes = map(category => {
    return (
      <CategoryRoleList
        key={category.name}
        allRoles={category.roles}
        categoryName={category.name}
        selectedRoles={filters.roles}
        toggleCategory={toggleCategory}
        toggleRole={toggleRole}
      />
    );
  }, categoriesWithRoles);
  return (
    <StyledForm>
      <StyledWrapper>
        <StyledChecklistTitle>
          View employees & shifts by category/role
        </StyledChecklistTitle>
        {checkboxes}
      </StyledWrapper>
    </StyledForm>
  );
}

export default Filters;
